import { IUserAwards } from '../roundFormatAwards/store';

export interface IAdminEventFormatAwardsStore {
  [eventId: number]: {
    [formatId: number]: IUserAwards;
  };
}

export const adminEventFormatAwardsStore: IAdminEventFormatAwardsStore = {};
